import ResponsibleSelect from './ResponsibleSelect';

export default ResponsibleSelect;
